export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/components/app-breadcrumbs/index.ts